import { FC } from "react";

const FilterByGender: FC<{
  maleFilter: boolean;
  femaleFilter: boolean;
  handleMaleFilterChange: () => void;
  handleFemaleFilterChange: () => void;
}> = ({
  maleFilter,
  femaleFilter,
  handleMaleFilterChange,
  handleFemaleFilterChange,
}) => {
  return (
    <div className="">
      <h4 className="font-bold">Gender</h4>
      <div className="flex items-center">
        <input
          type="checkbox"
          id="checkMale"
          name="checkMale"
          checked={maleFilter}
          onChange={handleMaleFilterChange}
          className="w-6 h-6 accent-primary rounded"
        />
        <label htmlFor="checkMale" className="ml-2 text-lg">
          Male
        </label>
      </div>
      <div className="flex items-center">
        <input
          type="checkbox"
          id="checkFemale"
          name="checkFemale"
          checked={femaleFilter}
          onChange={handleFemaleFilterChange}
          className="w-6 h-6 accent-primary rounded"
        />
        <label htmlFor="checkFemale" className="ml-2 text-lg">
          Female
        </label>
      </div>
    </div>
  );
};

export default FilterByGender;
